import { DataLoaderParams } from '@/types/DataLoaderParams';
import { loadAboutData } from '@/redux/modules/about.actions';

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return dispatch(loadAboutData());
};
